import CampaignBasicDetailsSlide from "./CampaignBasicDetailsSlide";

export default CampaignBasicDetailsSlide;
